import { Component, EventEmitter, Output } from '@angular/core';


@Component({
  selector: 'app-pin-pad',
  templateUrl: './pin-pad.component.html',
  styleUrls: ['./pin-pad.component.css'],
})
export class PinPadComponent {

  @Output()
  keyClick: EventEmitter<string> = new EventEmitter<string>();

  @Output()
  keyDeleteClick: EventEmitter<any> = new EventEmitter<any>();

  readonly deleteKeyChar = '<';

  keys = [
    ['1', '2', '3'],
    ['4', '5', '6'],
    ['7', '8', '9'],
    ['', '0', this.deleteKeyChar],
  ];

  constructor(
  ) { }

  onKeyClick(key: string): void {
    if(key === this.deleteKeyChar) {
      this.keyDeleteClick.emit();
      return;
    }
    this.keyClick.emit(key);
  }

}
